import baseAPI from '@/http'

const router = 'api/territorios-iniciativas-status'

export const territoriosIniciativasStatusAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
}
